// How long a user can be inactive (no mouse/keyboard/touch/scroll in any open tab)
// before being signed out. Tokens are only refreshed while the user is active.
export const IDLE_TIMEOUT_MINUTES = 60;

// How long before the idle sign-out the "you're about to be logged out" warning is shown.
export const IDLE_WARNING_MINUTES = 2;

export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000;
export const IDLE_WARNING_MS = IDLE_WARNING_MINUTES * 60 * 1000;
